<div class="d-flex justify-content-between my-4 my-xl-3 actions-section">
  <form>
    <fieldset class="d-flex flex-column flex-xl-row">
      <legend class="visuallyhidden">{{ scanIssues[$scanIssues.ruleId] }} {{ 'issues' | translate }}</legend>
      <div class="d-flex flex-wrap flex-lg-nowrap align-items-center">
        <select
          id="activityFilter"
          [ngModel]="filterByActivity"
          (ngModelChange)="filterByActivityChange.emit($event)"
          [ngModelOptions]="{ standalone: true }"
          [attr.aria-label]="'findings_by_status' | translate"
        >
          <option [ngValue]="null">{{ 'all' | translate }}</option>
          <option [ngValue]="false">{{ 'open' | translate }}</option>
          <option [ngValue]="true">{{ 'label_dismissed' | translate }}</option>
        </select>
        <app-download-report-new
          *appHasPermissions="downloadScanRequiredSecurity"
          class="btn-download ms-2"
          [scanId]="scanId"
          [ruleId]="scanIssues[$scanIssues.ruleId]"
          [auditTool]="scanIssues[$scanIssues.toolName]"
          [selectedIssues]="selectedIssues"
        ></app-download-report-new>
      </div>
    </fieldset>
  </form>
  <div class="hide-empty d-flex">
    @if (allDismissed() && (hasDismissFindingRequiredSecurity$ | async)) {
      <button
        ds-button
        [variant]="DsButtonVariants.microAction"
        [microActionIcon]="Icons.Eye"
        class="action-restore margin-right-md"
        [class.all-dismissed]="allDismissed()"
        (click)="openBulkIssuesActionModal()"
      >
        {{ 'label_restore_finding' | translate }}
      </button>
    }
    @if (hasDismissFindingRequiredSecurity$ | async) {
      <button
        ds-button
        [variant]="DsButtonVariants.microAction"
        [microActionIcon]="Icons.EyeSlash"
        class="action-dismiss margin-right-md"
        [class.all-dismissed]="allDismissed()"
        (click)="openBulkIssuesActionModal(true)"
      >
        {{ 'label_dismiss_finding' | translate }}
      </button>
    }
    @if (hasCreateTaskRequiredSecurity$ | async) {
      <button ds-button [variant]="DsButtonVariants.primary" class="create-task-button" (click)="openCreateTaskModal()">
        {{ 'label_create_task' | translate }}
      </button>
    }
  </div>
</div>
